module.exports = __webpack_public_path__ + "static/media/wa-icon--red.5bf32415.svg";